import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CrmSettingsService {

  private _settingData: any;
  showEnableDisableColumnSetting:any

  constructor(private http: HttpClient) { }


  // Getter
  get data(): any {
    return this._settingData;
  }

  // Setter
  set data(value: any) {
    this._settingData = value;
  }

  getCrmSettingFieldsList(): Observable<any>{
    return this.http.get<any>(`${environment.configUrlV2}/ModuleSetting`);
  }
}
